import api from '../http';
import { AxiosResponse } from 'axios';
import { Chat } from '../models/chat';


export interface IGetChatsResponse {
    chats: Chat[]
}

export default class ChatService {
    static async get(): Promise<AxiosResponse<IGetChatsResponse>> {
        return await api.get('chat');
    };
};